import { render } from "./AccountSettingsClient.vue?vue&type=template&id=437694d4"
import script from "./AccountSettingsClient.vue?vue&type=script&lang=js"
export * from "./AccountSettingsClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__